import { createFileRoute } from "@tanstack/react-router"
import { PageHeader } from "@/shared/components/layout/PageHeader"

export const Route = createFileRoute("/dashboard/")({
  component: DashboardPage,
  staticData: { authorize: true },
})

function DashboardPage() {
  return (
    <>
      <PageHeader title="Dashboard" description="Operations overview" />
      <div className="flex h-[calc(100vh-12rem)] items-center justify-center">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl font-semibold tracking-tight text-ink">Dashboard</h1>
          <p className="text-sm text-ink-3">Coming soon — Phase 4 of the modernization.</p>
        </div>
      </div>
    </>
  )
}
